import loadable from '@loadable/component';

const desktopTemplates = {
  brand: loadable(() => import('@catalogo/template-americanas-desktop-brand')),
  category: loadable(() => import('@catalogo/template-submarino-desktop-category')),
  home: loadable(() => import('@catalogo/template-submarino-desktop-home')),
  hotsite: loadable(() => import('@catalogo/template-americanas-desktop-hotsite')),
  mercado: loadable(() => import('@catalogo/template-americanas-desktop-mercado')),
  newsletter: loadable(() => import('@catalogo/template-submarino-desktop-newsletter')),
  'not-found': loadable(() => import('@catalogo/template-submarino-desktop-not-found')),
  'open-store-search': loadable(() => import('@catalogo/template-americanas-desktop-open-store-search')),
  'other-offers': loadable(() => import('@catalogo/template-submarino-desktop-other-offers')),
  product: loadable(() => import('@catalogo/template-submarino-desktop-product')),
  'public-list': loadable(() => import('@catalogo/template-americanas-desktop-public-list')),
  question: loadable(() => import('@catalogo/template-americanas-desktop-question')),
  report: loadable(() => import('@catalogo/template-americanas-desktop-report')),
  review: loadable(() => import('@catalogo/template-americanas-desktop-review')),
  search: loadable(() => import('@catalogo/template-submarino-desktop-search')),
  seller: loadable(() => import('@catalogo/template-americanas-desktop-seller')),
  sitemap: loadable(() => import('@catalogo/template-submarino-desktop-sitemap')),
  'store-category': loadable(() => import('@catalogo/template-americanas-desktop-store-category')),
  'store-list': loadable(() => import('@catalogo/template-americanas-desktop-store-list')),
  'store-offers': loadable(() => import('@catalogo/template-americanas-desktop-store-offers')),
  warranty: loadable(() => import('@catalogo/template-submarino-desktop-warranty')),
  'webpush-teste': loadable(() => import('@catalogo/template-americanas-desktop-webpush-teste')),
  wishlist: loadable(() => import('@catalogo/template-americanas-desktop-wishlist')),
  author: loadable(() => import('@catalogo/template-submarino-desktop-author')),
  error: loadable(() => import('@catalogo/template-submarino-desktop-error')),
};

export default desktopTemplates;
